/* unplugin-vue-components disabled */import script from "./activity-update.vue?vue&type=script&setup=true&lang=js"
export * from "./activity-update.vue?vue&type=script&setup=true&lang=js"

import "./activity-update.vue?vue&type=style&index=0&id=d263df2c&lang=scss"

const __exports__ = script;

export default __exports__